
import { Field,reduxForm, initialize } from 'redux-form';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdditionServiceCheckbox from '../components/AdditionServiceCheckbox';
import * as homeActions from '../actions/homeActions';
import LoadingOverlay from '../components/LoadingOverlay';
import ReactGA from 'react-ga';



class AdditionalServiceForm extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            cookiesAccepted: false,
        };
    }

    componentDidMount() {
        window.addEventListener('CookiebotOnAccept', () => {
            this.setState({ cookiesAccepted: true });
        });}

    componentWillUnmount() {
        window.removeEventListener('CookiebotOnAccept', () => {
            this.setState({ cookiesAccepted: false });
        });}



    render(){
        const {ancillaryServices,handleOptionalServiceChange,isLoading}=this.props;
        let {selectedOptionalServices}=this.props.locationDetail;
        return(
            <div className="row">
                <LoadingOverlay loading={isLoading} spinnerStyle={{ top: "20%" }}>
                    <form>
                    <div className="account-card">
                        <div className="row header">
                            <div className="col-12 col-md-12">
                                <label>Additional Services</label>
                             </div>
                        </div>
                    
                    {
                                        ancillaryServices.map((service,index)=>{
                                            let isActive=selectedOptionalServices.filter(s=>s.id==service.id).length>0;

                                            return (
                                                <div className="row" key={index}>
                                                    <div className="col-md-12">
                                                        <Field name={`${service.id}`} key={index} component={props => {
                                                             return (<AdditionServiceCheckbox isChecked={isActive}
                                                                    label={service.description}
                                                                    onChange={param => handleOptionalServiceChange(props,param)} 
                                                                    price={service.grossAmount} key={index}/>);
                                                            }
                                                        } />
                                                    </div>
                                                </div>
                                            )

                                        })
                                    }
                    </div>
                   
                    </form>
                </LoadingOverlay>

            </div>
            




            
          )

        
        
    }
    
}

AdditionalServiceForm.propTypes = {
    isLoading: PropTypes.bool,
    ancillaryServices:PropTypes.arrayOf(PropTypes.object),
    selectedServices:PropTypes.arrayOf(PropTypes.string),
    handleOptionalServiceChange:PropTypes.func.isRequired,
    locationDetail:PropTypes.object,


};
function mapStateToProps(state) {
    return {
        locationDetail: state.locationDetail,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(homeActions, dispatch)
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(reduxForm({
    form: 'additionalServiceform',
    onSubmitSuccess: (result, dispatch, props) => {
        dispatch(initialize(props.form, props.values));
        if (this.state.cookiesAccepted) {
        ReactGA.event({
            category: 'service',
            action: 'additaional servivce'
          });
        }
    }
})(AdditionalServiceForm));





// WEBPACK FOOTER //
// ./src/forms/AdditionalServiceForm.jsx